@if (profile && profile.isMYsecAvailable) {
  <page name="raise.shareholdersDashboard">
    <app-ticker-code></app-ticker-code>
    <app-shareholder-information [tickerCodes]="tickerCodes"></app-shareholder-information>
    <app-share-movement-tracker [tickerCodes]="tickerCodes"></app-share-movement-tracker>
  </page>
} @else {
  @if (isLoading) {
    <agmo-loading></agmo-loading>
  }
  @if (!isLoading) {
    <div class="container-fluid">
      <div class="tw-p-5 tw-pt-10 tw-text-center">
        <span>{{ 'mysec.noDigitalRegistry' | translate }}</span>
      </div>
    </div>
  }
}
